import {
  CreateIdKortOrderModel,
  IdKortOrderCreatedModel,
} from "../interfaces/idkort";
import { postFormWithoutAuthRedirect } from "./util";

export async function createIdKortOrder(model: CreateIdKortOrderModel) {
  const formData = new FormData();
  formData.append("foto", model.foto);

  if (model.bemaerkninger?.trim()) {
    formData.append("bemaerkninger", model.bemaerkninger.trim());
  }

  return postFormWithoutAuthRedirect<IdKortOrderCreatedModel>({
    query: "IdKort",
    body: formData,
  });
}
